import axios from "axios";
import { API_URL } from "../utils/Constant.jsx";
import { store } from '../app/store.jsx';
import { performLogout } from "./utils.jsx";
import { refreshAccessToken } from "../api/api.js";
import { logoutUser } from "../app/slice/thunk/authActions.js";


const axiosInstance = axios.create({
  baseURL: API_URL,  // Replace with your base URL
  // timeout: 10000,  // Optional: Set the timeout for requests
});

axiosInstance.interceptors.request.use(
  (config) => {
    const customParams = config.customParams || {};
    const accessToken = store.getState().auth.accessToken;  // Access the refresh token from auth slice
    if (accessToken) {
      // Set the Authorization header for the request if the token exists
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
        // Dynamically add query parameters (params) to GET requests
        if ( config.method === 'get' || config.method === 'delete' ) {
          config.params = {
            ...config.params,  // Keep any existing params intact
            ...customParams,  // Merge any dynamic params
          };
        }

   // Dynamically set Content-Type based on the request body
   if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else if (config.data) {
    // If there is data and it's not FormData, assume it's JSON
    config.headers['Content-Type'] = 'application/json';
  }

    // You can also handle any other logic before sending the request
    return config;
  },
  (error) => {
    // Handle any errors with the request itself (e.g., network issues)
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const { response } = error;

    if (response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = store.getState().auth.refreshToken;

      if (!refreshToken) {
        performLogout(); // ✅ Use shared logout here
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers["Authorization"] = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            },
            reject: (err) => reject(err),
          });
        });
      }

      isRefreshing = true;

      try {
        const newAccessToken = await refreshAccessToken(refreshToken);
        console.log(newAccessToken, 'newAccessToken 00 11')
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        processQueue(null, newAccessToken);
        return axiosInstance(originalRequest);
      } catch (err) {
        console.log(err, 'newAccessToken 00 33')
        store.dispatch(logoutUser());
        performLogout(); 
        // processQueue(err, null);
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;


